import { useEffect, useState } from "react";
import axios from "axios";
import { Newspaper } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Insights = () => {
  const { t, lang } = useLanguage();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/insights`).then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  if (!items.length) return null;

  const fmtDate = (d) =>
    new Date(d).toLocaleDateString(lang === "pl" ? "pl-PL" : "en-GB", { day: "numeric", month: "long", year: "numeric" });

  return (
    <div className="mt-14" data-testid="insights-feed">
      <Reveal>
        <div className="mb-6 flex items-center gap-3">
          <span className="grid h-8 w-8 place-items-center rounded-full bg-brand-600 text-white">
            <Newspaper size={14} />
          </span>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">{t.about.insightsLabel}</span>
        </div>
      </Reveal>
      <div className="grid gap-5 md:grid-cols-2">
        {items.slice(0, 4).map((n, i) => (
          <Reveal key={n.id} delay={i * 0.06}>
            <article
              data-testid={`insight-${n.id}`}
              className="h-full rounded-2xl border border-neutral-200 bg-white p-6 transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_24px_50px_-30px_rgba(44,56,28,0.35)]"
            >
              <div className="flex flex-wrap items-center gap-3 font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-400">
                {n.tag && <span className="rounded-full bg-brand-100 px-2.5 py-0.5 font-medium text-brand-700">{n.tag}</span>}
                <time dateTime={n.created_at}>{fmtDate(n.created_at)}</time>
              </div>
              <h4 className="mt-3 font-display text-lg font-bold leading-snug text-neutral-950">{n.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-neutral-500">{n.body}</p>
              <div className="mt-4 font-mono text-[10px] tracking-[0.18em] text-neutral-400">— {n.author || "GREGORY RADEK"}</div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  );
};
